const apiKey = 'AIzaSyBm1YEu1BpVwYSxqQ4gTKAAvLonazUujiE';
export default apiKey;
